export *from './home.component';


// WEBPACK FOOTER //
// ./app/insa-components/insa-home/index.ts